import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    eventId: String,
    groupId: String,
    contentType: String,
    largeCategory: String,
    smallCategory: String,
  };

  dashboard(event) {
    window.trEventClick(event.target, document.title, this.contentTypeValue, "ページ遷移", {
      org_00: "promoter_dashboard",
      org_01: this.eventIdValue || undefined,
      org_02: this.contentTypeValue || undefined,
      org_03: this.largeCategoryValue || undefined,
      org_04: this.smallCategoryValue || undefined,
    });
  }

  createAnnounce(event) {
    window.trEventClick(event.target, document.title, "登録する", "アンケート作成完了", {
      org_00: "promoter_create_announce",
      org_01: this.eventIdValue || undefined,
      org_02: this.largeCategoryValue || undefined,
      org_03: this.smallCategoryValue || undefined,
    });
  }

  createInquiry(event) {
    window.trEventClick(event.target, document.title, "送信する", "メール送信完了", {
      org_00: "promoter_create_inquiry",
      org_01: this.eventIdValue || undefined,
      org_02: this.largeCategoryValue || undefined,
      org_03: this.smallCategoryValue || undefined,
    });
  }

  relation(event) {
    window.trEventClick(event.target, document.title, this.contentTypeValue, "外部共有ページ遷移", {
      org_00: "promoter_relation",
      org_01: this.eventIdValue || undefined,
      org_02: this.contentTypeValue || undefined,
      org_03: this.largeCategoryValue || undefined,
      org_04: this.smallCategoryValue || undefined,
    });
  }

  createEventStart(event) {
    window.trEventClick(event.target, document.title, "新規イベント作成", "イベント作成画面遷移", {
      org_00: "promoter_create_event_start",
    });
  }

  createGroup(event) {
    window.trEventClick(event.target, document.title, "公開ボタン", "イベントグループ公開完了", {
      org_00: "promoter_create_group",
      org_01: this.groupIdValue || undefined,
    });
  }
}
